<template>
  <div class="page">
    <div class="div-header-select div-2-top">
      <div class="div-center">
        <div class="div-title">时间：</div>
        <el-date-picker
          style="width: 320px"
          size="medium"
          v-model="applicantDate"
          type="daterange"
          range-separator="至"
          start-placeholder="申请开始日期"
          end-placeholder="申请结束日期"
        >
        </el-date-picker>
        <el-date-picker
          style="margin-left: 5px; width: 320px"
          size="medium"
          v-model="reviewDate"
          type="daterange"
          range-separator="至"
          start-placeholder="审核开始日期"
          end-placeholder="审核结束日期"
        >
        </el-date-picker>
      </div>
    </div>

    <main>
      <el-table 
           @header-click="headerClickReceipt" 
           height="calc(100vh - 200px)"  :data="listData" @cell-mouse-enter="cellMouseEnter" style="width: 100%">
        <template slot="empty">
          <img
            src="../../assets/list-none.png"
            alt=""
            width="400"
            class="table-empty"
          />
          <div>空荡荡的～暂无数据！</div>
        </template>
        <el-table-column prop="apiName" label="操作名称" align="center">
        </el-table-column>
        <!-- <el-table-column prop="applicantName" label="申请人" align="center">
        </el-table-column> -->
        <el-table-column v-if="!applicantInput" prop="applicantName"   width="240px" align="center" key="applicant_1">
              <template slot="header">
                <div style="color:#409EFF;" >
                  <span >申请人 </span>
                  <i class="el-icon-search" ></i>
                </div>
              </template>  
            </el-table-column>
            <el-table-column v-if="applicantInput" prop="applicantName"  label="申请人" width="240px"  align="center" key="applicant_2">
                <template slot="header" slot-scope="scope">
                  <el-input
                    v-model="queryApplicant"
                    size="mini"
                    placeholder="申请人"
                    clearable
                     v-focus  
                     maxlength="13"
                    @blur="recoverReceipt"
                    @keyup.enter.native="query(0)"
                    @clear="clearApplicantInput"
                  />
                </template> 
                <!-- 
                  autofocus是vue中input的原生属性,element也支持这种方法,
                  但是如果el-input组件外面还有其他组件, 就会导致autofocus失效。
                  解决办法：

                  自定义指令

                  在全局定义一个自动获取焦点的自定义指令，在所有组件中都可以使用v-focus来自动获取焦点。
                  v-focus 是自定义全局指令  
                  参见：https://blog.csdn.net/weixin_46074961/article/details/120350817?spm=1001.2101.3001.6650.1&utm_medium=distribute.pc_relevant.none-task-blog-2%7Edefault%7ECTRLIST%7Edefault-1.no_search_link&depth_1-utm_source=distribute.pc_relevant.none-task-blog-2%7Edefault%7ECTRLIST%7Edefault-1.no_search_link
                  -->
            </el-table-column>
        <el-table-column prop="refundAmount" label="金额(元)" align="right">
          <template slot-scope="scope" >
            <strong >{{ numFormat(scope.row.refundAmount) }}</strong>
          </template>
        </el-table-column>
        <el-table-column prop="refundComment" label="说明" align="center">
        </el-table-column>
        <el-table-column prop="createdTime" label="申请时间" width="200px"  align="center">
        </el-table-column>
        <!-- <el-table-column prop="reviewName" label="审核人" align="center">
        </el-table-column> -->
        <el-table-column v-if="!reviewInput" prop="reviewName"   width="200px" align="center" key="review_2_1">
              <template slot="header">
                <div style="color:#409EFF;" >
                  <span >审核人 </span>
                  <i class="el-icon-search" ></i>
                </div>
              </template>  
            </el-table-column>
            <el-table-column v-if="reviewInput" prop="reviewName"  label="审核人" width="200px"  align="center" key="review_2">
                <template slot="header" slot-scope="scope">
                  <el-input
                    v-model="queryReview"
                    size="mini"
                    placeholder="审核人"
                    clearable
                     v-focus  
                     maxlength="13"
                    @blur="recoverReceipt"
                    @keyup.enter.native="query(0)"
                    @clear="clearReviewInput"
                  />
                </template> 
                <!-- 
                  autofocus是vue中input的原生属性,element也支持这种方法,
                  但是如果el-input组件外面还有其他组件, 就会导致autofocus失效。
                  解决办法：

                  自定义指令

                  在全局定义一个自动获取焦点的自定义指令，在所有组件中都可以使用v-focus来自动获取焦点。
                  v-focus 是自定义全局指令  
                  参见：https://blog.csdn.net/weixin_46074961/article/details/120350817?spm=1001.2101.3001.6650.1&utm_medium=distribute.pc_relevant.none-task-blog-2%7Edefault%7ECTRLIST%7Edefault-1.no_search_link&depth_1-utm_source=distribute.pc_relevant.none-task-blog-2%7Edefault%7ECTRLIST%7Edefault-1.no_search_link
                  -->
            </el-table-column>
        <el-table-column prop="status" width="120vw" label="审核状态" align="center">
          <template slot-scope="scope" >
            <el-popover trigger="click" placement="top">
              <p v-if="scope.row.comment ==''">{{ "无信息" }}</p>
              <p>{{ scope.row.comment }}</p>
              <div slot="reference"  class="name-wrapper">
                <el-button   size="mini"  style="padding: 5px 5px; width:80px;"  type="success" round v-if="scope.row.status=='通过'">{{ scope.row.status }}<i class="el-icon-info el-icon--right"></i></el-button >
                <el-button size="mini"  style="padding: 5px 5px; width:80px;" type="danger" round v-else-if="scope.row.status=='未通过'" >{{ scope.row.status }}<i class="el-icon-info el-icon--right"></i></el-button>
                <el-button size="mini"  style="padding: 5px 5px; width:80px;"  type="primary" round v-else-if="scope.row.status=='待审核'" >{{ scope.row.status }}<i class="el-icon-info el-icon--right"></i></el-button>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="执行状态"  width="140vw" align="center">
          <template slot-scope="scope">
            <el-popover trigger="click" opper-class="el-popover"  placement="top">
              <p v-if="scope.row.doComment ==''">{{ "无信息" }}</p>
              <p>{{ scope.row.doComment }}</p>
              <div slot="reference" class="name-wrapper">
                <el-button   size="mini"  style="padding: 5px 5px; width:80px;"  type="success" round v-if="scope.row.doStatus=='执行成功'">{{ scope.row.doStatus }}<i class="el-icon-info el-icon--right"></i></el-button >
                <el-button size="mini"  style="padding: 5px 5px; width:80px;" type="danger" round v-else-if="scope.row.doStatus=='执行失败'" >{{ scope.row.doStatus }}<i class="el-icon-info el-icon--right"></i></el-button>
                <el-button size="mini"  style="padding: 5px 5px; width:80px;"  type="primary" round v-else-if="scope.row.doStatus=='待执行'" >{{ scope.row.doStatus }}<i class="el-icon-info el-icon--right"></i></el-button>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="reviewTime" label="审核时间" align="center">
        </el-table-column>
        <el-table-column label="操作" width="240px"  align="center">
          <template slot-scope="scope" v-if='scope.row.status=="待审核"'>
            <el-button
              type="primary"
              plain
              size="mini"
              @click="reviewYes(scope.row)" 
            >通过</el-button>
            <el-button
              type="danger"
              plain
              size="mini"
              @click="reviewNo(scope.row)"
            >不通过</el-button>
          </template>
        </el-table-column>
      </el-table>
    </main>

    <footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIdx"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="itemTotal"
        :page-sizes="[10, 20, 30, 40, 50]"
      >
      </el-pagination>
    </footer>
  </div> 
</template>

<script>
import axios from "axios";
import Utils from "../../Utils";
import { Loading } from "element-ui";
import FileUpload from "./FileUpload";
import mixins from "../../minix";

let _vue;

export default {
  mixins: [mixins],
  name: "home",
  components: { FileUpload },

  data() {
    return {
      applicantDate:"",
      reviewDate:"",
      queryApplicant:"",//查询申请人名称
      queryReview:"",//查询审核人名称
      applicantInput:false,
      reviewInput:false,
      pageIdx: 0,
      itemTotal: 0,
      dialogVisible: false,
      listData: [],
      state: "",

      houseNameRegex: "",
      areaID: "",
      areasMap: new Map(),
      reviewStatus:"",
      dialogUploadVisible: false,
      dialogUploadFile: "",

      dialogBillsVisible: false,

      pricings: []
    };
  },

  created() {
    localStorage.setItem("token", this.$route.query.token || "");
    localStorage.setItem("orgID", this.$route.query.orgID || "");
    localStorage.setItem("type", "Web_Admin");

    this.query(0);

    _vue = this;
  },

  watch: {
    state() {
      this.initQuery();
    },
    applicantDate() {
      this.initQuery();
    },

    reviewDate() {
      this.initQuery();
    },
  },

  methods: {
    
    clearApplicantInput(){
      this.applicantInput=false
      this.query(0)
    },
    clearReviewInput(){
      this.reviewInput=false
      this.query(0)
    },
    headerClickReceipt(column, event){
      if (column.property=="applicantName"){
        this.applicantInput = true
      }
      if (column.property=="reviewName"){
        this.reviewInput = true
      }

    },
    recoverReceipt(event){
      if(!this.queryApplicant){
        this.applicantInput=false
      }
      if(!this.queryReview){
        this.reviewInput=false
      }
    },
     cellMouseEnter(row, column, cell,event) {   //控制展开行
      // let NoIndex = column.type.indexOf("expand"); 
    },
    handleCurrentChange(val) {
      // eslint-disable-next-line no-console
      this.pageIdx = val;
      this.query(val - 1);
    },

    handleSizeChange(val) {
      // eslint-disable-next-line no-console
      this.pageIdx = 0;
      this.pageSize = val;
      this.query(0);
    },

    // 审核通过
    reviewYes(item) {
      let _vue = this;
      _vue.reviewStatus = "通过"
      this.review(item)
    },

    // 审核不通过
    reviewNo(item) {
      let _vue = this;
      _vue.reviewStatus = "未通过"
      
      this.review(item)
    },
    review (item){
      this.$prompt(
              `请输入审核说明`,
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
              }
            )
              .then(({ value }) => {
                const loading = Loading.service({
                  lock: true,
                  text: "正在请求中",
                  spinner: "el-icon-loading",
                  background: "rgba(0, 0, 0, 0.1)"
                });
                axios({
                  method: "post",
                  url: "reviewrecords/review",
                  data: {
                    recordID: item.id,
                    comment: value,
                    status: _vue.reviewStatus,
                  }
                })
                  .then(value => {
                    if (value.data.code === 0) {
                      this.$message.success(value.data.message);
                    } else {
                      this.$message.error(value.data.message);
                    }
                  })
                  .finally(() => {
                      loading.close();
                    _vue.query(_vue.pageIdx - 1);
                  });
              })
              .catch(() => {});
    },

    initQuery() {
      this.pageIdx = 0;
      this.query(0);
    },
    //列表查询
    query(pageIdx) {
      if (pageIdx <= 0) {
        pageIdx = 0;
      }

      let data = {
        pageSize: this.pageSize,
        pageIdx: pageIdx,
        orgID:this.$route.query.orgID ,
        applicantName:this.queryApplicant,
        reviewName:this.queryReview,
      };
      if (Array.isArray(this.applicantDate)) {
        data.applicantStart = parseInt(this.applicantDate[0].getTime() / 1000);
        data.applicantEnd = parseInt(
          this.applicantDate[1].getTime() / 1000 + 60 * 60 * 24 - 1
        );
      }

      if (Array.isArray(this.reviewDate)) {
        data.reviewStart = parseInt(this.reviewDate[0].getTime() / 1000);
        data.reviewEnd = parseInt(
          this.reviewDate[1].getTime() / 1000 + 60 * 60 * 24 - 1
        );
      } 
      const loading = Loading.service({
        lock: true,
        text: "正在请求中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });

      axios({
        method: "post",
        url: "refundrecords",
        data: data
      })
        .then(value => {
          if (value.data.code != 0) {
            this.$message.error(value.data.message);
          }else{
            this.listData = [];
            this.itemTotal = value.data.total;
            if (value && value.data && value.data.data) {
              value.data.data.forEach(item => {
                //申请内容
                item.refundAmount =item.refundAmount/100;
                item.createdTime = Utils.long2second(item.createdTime * 1000);
                item.reviewTime = Utils.long2second(item.reviewTime * 1000);
                if(item.status=="待审核"){
                  item.reviewTime=""
                }
                this.listData.push(item);
              });
            }
          }
        })
        .catch(() => {})
        .finally(() => {
          loading.close();
        });
    }
  }
};
</script>

<style>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.el-input-group__prepend {
  width: 140px !important;
}
.el-input-group--prepend {
  margin-bottom: 10px;
}
.el-popover{
    background-color: #242527!important;
    color: #ffffff!important; 
    padding: 0px!important;
}
.el-popper[x-placement^=top]
.popper__arrow::after {
    bottom: 1px;
    margin-left: -6px;
    border-top-color: #242527;
    border-bottom-width: 0;
}
</style>

<style lang="scss" scoped>
@import "../../style.css";
main {
  margin-top: 10px;
}
.header-title {
  width: 150px;
}
</style>
